import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=5b7bd0fa&scoped=true&"
import script from "./BankForm.vue?vue&type=script&lang=js&"
export * from "./BankForm.vue?vue&type=script&lang=js&"
import style0 from "./BankForm.vue?vue&type=style&index=0&id=5b7bd0fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7bd0fa",
  null
  
)

export default component.exports